/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {

    className: 'quotes-testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '#quotes-testimonial-slider__top-splide' ).length ) {
        $( '#quotes-testimonial-slider__top-splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            perPage: 1,
            gap: '2rem',
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoHeight: true,
            autoScroll: {
              speed: .75,
              pauseOnFocus: true,
              pauseOnHover: true,
            },
            breakpoints: {
              768: {
                destroy: true,
              },
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
      if ( $( '#quotes-testimonial-slider__bottom-splide' ).length ) {
        $( '#quotes-testimonial-slider__bottom-splide' ).each( function( index, element ) {
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            perPage: 1,
            direction: 'rtl',
            gap: '2rem',
            autoWidth: true,
            arrows: false,
            pagination: false,
            autoHeight: true,
            autoScroll: {
              speed: .75,
              pauseOnFocus: true,
              pauseOnHover: true,
            },
            breakpoints: {
              768: {
                arrows: true,
                autoScroll: false,
                direction: 'ltr',
              },
            },
          } );
          slider.mount( {AutoScroll} );
        } );
      }
      const bgColor = [
        'brand-blue',
        'brand-green',
        'brand-orange',
      ];
      const svgColor = ['#5cbaf8', '#02db6e', '#ff9121'];
      let currentBgColorKey = 0;
      $( '.quotes-testimonial-slider_top-marquee-wrapper .splide__slide' ).each( function() {
        const svgCode = `<svg class="w-[60%] absolute " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290"><path d="M22.12 145v97.65h97.65V145H70.95c0-26.92 21.9-48.82 48.82-48.82V47.35c-53.93 0-97.65 43.72-97.65 97.65zm245.76-48.82V47.35c-53.93 0-97.65 43.72-97.65 97.65v97.65h97.65V145h-48.82c-.01-26.92 21.89-48.82 48.82-48.82z" fill=""></path></svg>`;
        const svg = document.createElementNS( 'http://www.w3.org/2000/svg', 'svg' );
        svg.setAttribute( 'viewBox', '0 0 290 290' );
        svg.setAttribute( 'class', 'w-[20%] absolute top-0 left-[10px] z-10' );
        svg.setAttribute( 'style', 'opacity: 40%;' );

        const path = document.createElementNS( 'http://www.w3.org/2000/svg', 'path' );
        path.setAttribute( 'd', 'M22.12 145v97.65h97.65V145H70.95c0-26.92 21.9-48.82 48.82-48.82V47.35c-53.93 0-97.65 43.72-97.65 97.65zm245.76-48.82V47.35c-53.93 0-97.65 43.72-97.65 97.65v97.65h97.65V145h-48.82c-.01-26.92 21.89-48.82 48.82-48.82z' );
        path.setAttribute( 'fill', svgColor[currentBgColorKey] );
        svg.appendChild( path );
        $( this ).append( svg );
        $( this ).find( '.testimonial-slide__circle' ).addClass( 'bg-'+bgColor[currentBgColorKey] );
        if ( currentBgColorKey === 2 ) {
          currentBgColorKey = 0;
        } else {
          currentBgColorKey ++;
        }
      } );
      $( '.quotes-testimonial-slider_bottom-marquee-wrapper .splide__slide' ).each( function() {
        const sliderHeight = $( this ).find( '.slide-content' ).innerHeight();
        $( this ).innerHeight( sliderHeight+'px' );

        $( this ).find( '.testimonial-slide__circle' ).addClass( 'bg-'+bgColor[currentBgColorKey] );
        if ( currentBgColorKey === 2 ) {
          currentBgColorKey = 0;
        } else {
          currentBgColorKey ++;
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'quotes-testimonial-slider', COMPONENT );
} )( app );
